import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, CardHeader } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import LabeledReadOnly from "../../components/LabeledReadOnly";
import { makeStyles } from "@material-ui/core/styles";
import ReadOnlyField from "../../components/ReadOnlyField";
import { DateTime } from "luxon";
import { notBlank } from "../../util/ext";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {
  generateFilename,
  getDownloadUrl,
} from "./processingDiscoveryServices";
import DownloadIcon from "@material-ui/icons/SaveAlt";
import { useSelector } from "react-redux";

const useStyles = makeStyles(theme => ({
  header: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },

  content: {
    paddingTop: 0,
  },
}));

const ContentMetadataParseEventCard = ({ contentMetadataParseEvent }) => {
  const classes = useStyles();
  const auth = useSelector(state => state.auth);

  const [metadataDownloadUrl, setMetadataDownloadUrl] = useState(null);
  useEffect(() => {
    async function fetchData() {
      const url = await getDownloadUrl(
        auth,
        contentMetadataParseEvent.contentMetadataFileLocation,
      );
      setMetadataDownloadUrl(url);
    }

    fetchData();
  }, [auth, contentMetadataParseEvent]);

  return (
    <Card raised elevation={4} style={{ height: "100%" }}>
      <CardHeader
        titleTypographyProps={{
          variant: "h6",
          color: "primary",
        }}
        title="Details"
        classes={{ root: classes.header }}
      />
      <CardContent classes={{ root: classes.content }}>
        <Grid container spacing={3}>
          <Grid item sm={6}>
            <LabeledReadOnly label="Event Timestamp">
              <ReadOnlyField>
                {DateTime.fromISO(contentMetadataParseEvent.eventTimestamp)
                  .toUTC()
                  .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={6}>
            <LabeledReadOnly label="Media Id">
              <ReadOnlyField>{contentMetadataParseEvent.mediaId}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={12}>
            <LabeledReadOnly label="Job Id">
              <ReadOnlyField>{contentMetadataParseEvent.jobId}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={12}>
            <LabeledReadOnly label="Execution Id">
              <ReadOnlyField>
                {contentMetadataParseEvent.executionId}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={6}>
            <LabeledReadOnly label="Product Code">
              <ReadOnlyField>
                {contentMetadataParseEvent.productCode}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={6}>
            <LabeledReadOnly label="ISBN">
              <ReadOnlyField>{contentMetadataParseEvent.isbn}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={12}>
            <LabeledReadOnly label="Title">
              <ReadOnlyField>{contentMetadataParseEvent.title}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item sm={12}>
            <LabeledReadOnly label="Content Metadata File Location">
              <Box display="flex" alignSelf="center">
                <Box>
                  <ReadOnlyField>
                    {contentMetadataParseEvent.contentMetadataFileLocation}
                  </ReadOnlyField>
                </Box>
                {notBlank(metadataDownloadUrl) && (
                  <Box mt={-2.5}>
                    <Tooltip title="Download">
                      <IconButton
                        href={metadataDownloadUrl}
                        target="_blank"
                        download={generateFilename(
                          contentMetadataParseEvent.contentMetadataFileLocation,
                        )}
                      >
                        <DownloadIcon color="primary" fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
              </Box>
            </LabeledReadOnly>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ContentMetadataParseEventCard;
